document.addEventListener('DOMContentLoaded', () => {

  // Unix timestamp (in seconds) to count down to
  let blackweekend = 1764629940;

  // Set up FlipDown
  let flipdown = new FlipDown(blackweekend, {
  theme: "light", headings: ["Days", "Hours", "Minutes", "Seconds"],
})

    // Start the countdown
    .start()
  
  var ver = document.getElementById('ver');
  ver.innerHTML = flipdown.version;
});